const DAY_IN_MS = 24 * 60 * 60 * 1000;

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const getExpirationLabel = (expiresIn: string, waitCancel: boolean) => {
	const expirationDate = new Date(expiresIn);
	const daysUntil = Math.round(
		(startOfDay(expirationDate).getTime() - startOfDay(new Date()).getTime()) / DAY_IN_MS,
	);
	const verb = waitCancel ? 'Encerra' : 'Vence';

	if (daysUntil <= 0) return { label: `${verb} hoje`, isToday: true };
	if (daysUntil === 1) return { label: `${verb} amanhã`, isToday: false };

	return {
		label: `${verb} ${expirationDate.toLocaleDateString('pt-BR', { weekday: 'long' })}`,
		isToday: false,
	};
};
